// src/utils/chatConfig.ts

declare global {
  interface Window {
    lcw: () => any;
  }
}

export const setupChatConfig = (): void => {
  window.lcw = () => {
    return {
      loadingPaneProps: {
        controlProps: {
          hideLoadingPane: false
        },
        styleProps: {
          generalStyleProps: {
            background: "#E6EAF2"
          },
          iconStyleProps: {
            backgroundColor: "#00469B"
          },
          iconImageProps: {
            backgroundColor: "#00469B"
          },
          titleStyleProps: {
            color: "#00469B"
          },
          subtitleStyleProps: {
            color: "#00469B"
          },
          spinnerTextStyleProps: {
            color: "#00469B"
          }
        }
      },
      headerProps: {
        styleProps: {
          generalStyleProps: {
            backgroundColor: "#00469B",
          }
        }
      },
      chatButtonProps: {
        styleProps: {
          iconStyleProps: {
            backgroundColor: "#00469B"
          }
        }
      },
      confirmationPaneProps: {
        styleProps: {
          confirmButtonStyleProps: {
            backgroundColor: "#00469B"
          },
          confirmButtonHoveredStyleProps: {
            backgroundColor: "#065BC2"
          },
          confirmButtonFocusedStyleProps: {
            backgroundColor: "#00469B"
          }
        }
      },
      webChatContainerProps: {
        renderingMiddlewareProps: {
          avatarStyleProps: {
            backgroundColor: "#00469B"
          }
        },
        adaptiveCardStyles: {
          backgroundColor: "#00469B"
        },
        webChatStyles: {
          suggestedActionBorderColor: "#00469B",
          suggestedActionTextColor: "#00469B",
          bubbleFromUserBackground: "white",
          bubbleFromUserTextColor: "black"
        }
      }
    };
  };
};